export { default } from "./SpinLoader";